import {
  deleteFromUploaderCallback,
  downloadImportExampleFileCallback,
  uploadFileCallback,
} from "Pages/ImportWizard/recoil/callbacks";
import { uploaderState } from "Pages/ImportWizard/recoil/state/stateStep1";
import styled from "@emotion/styled";
import {
  Flex,
  FlexItem,
  Icon60CancelCircle,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  Panel,
  SpacingVertical,
  TEXT_VARIANT_BOLD,
  Text,
  Title,
  UPLOADER_VARIANT_DANGER,
  UPLOADER_VARIANT_DEFAULT,
  UPLOADER_VARIANT_UPLOADED,
  UPLOADER_VARIANT_UPLOADING,
  Uploader,
  UploadingFile,
} from "mailup-web-components";
import React, { type FC } from "react";
import { useIntl } from "react-intl";
import { useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { gainsightTrack } from "mailup-react-helpers";

const FileUploader: FC = () => {
  const intl = useIntl();

  const [{ variant, hintDanger, file }, _setUploaderState] =
    useRecoilState(uploaderState);

  const uploadFile = useRecoilCallback(uploadFileCallback, []);
  const deleteFromUploader = useRecoilCallback(deleteFromUploaderCallback, []);
  const downloadImportExampleFile = useRecoilCallback(
    downloadImportExampleFileCallback,
    [],
  );

  const downloadFileExample = () => {
    gainsightTrack("mup_importWizard_clickDownloadSamplesFile", {});

    downloadImportExampleFile();
  };

  const defaultInner = (
    <span>
      {intl.formatMessage(
        {
          id: "Load.FileImport.UploaderTitle",
        },
        {
          link: (chunks) => (
            <label htmlFor="uploader-file-to-import">{chunks}</label>
          ),
        },
      )}
    </span>
  );

  const value =
    variant === UPLOADER_VARIANT_UPLOADING && file ? (
      <UploadingFile
        name={file.name}
        size={`${intl.formatNumber(file.size)} KB`}
      />
    ) : undefined;

  const hint =
    variant === UPLOADER_VARIANT_DANGER ? (
      hintDanger
    ) : variant === UPLOADER_VARIANT_UPLOADED ? (
      <StyledUploadedHint showLink={hintDanger}>
        <Flex alignItems="center" justifyContent="center">
          <StyledText variant={TEXT_VARIANT_BOLD}>{file?.name}</StyledText>

          <FlexItem margin="0 0 0 8px">
            <div
              onClick={() => {
                gainsightTrack("mup_importWizard_clickXonUploadedFile", {});

                deleteFromUploader();
              }}
            >
              {!hintDanger && <Icon60CancelCircle />}
            </div>
          </FlexItem>
        </Flex>
      </StyledUploadedHint>
    ) : (
      intl.formatMessage({
        id: "Load.FileImport.UploaderDescr",
      })
    );

  const handleChange = (e: File[] | null) => {
    gainsightTrack("mup_importWizard_clickChooseAFileSelector", {});
    gainsightTrack("mup_importWizard_clickFileUploadSelector", {});

    uploadFile(e);
  };

  return (
    <Panel>
      <Title variant="M">
        {intl.formatMessage({ id: "Load.FileImport.UploadFile" })}
      </Title>
      <SpacingVertical variant="16" />
      <Text>
        {intl.formatMessage(
          { id: "Load.FileImport.UploadFileDescr" },
          {
            link: (chunks) => (
              <Link
                variant={LINK_VARIANT_HIGHLIGHT}
                onClick={downloadFileExample}
              >
                {chunks}
              </Link>
            ),
          },
        )}
      </Text>
      <SpacingVertical />
      <Uploader
        inputId="uploader-file-to-import"
        multiple={false}
        variant={variant}
        hint={hint}
        //accept={ACCEPTED_FILE_IMPORT_EXT}
        value={value}
        onChange={handleChange}
      >
        {defaultInner}
      </Uploader>
    </Panel>
  );
};
export default FileUploader;

const StyledUploadedHint = styled.div`
  p{
    cursor: default;
  }
  svg{
      cursor: pointer;
  }
  & > :last-child {
    font-size: 21px;

    svg path {
      stroke: var(--java);
      stroke-width: 2px;
    }
    & > :hover {
      svg path {
        stroke: var(--blue-chill);
      }
    
    }
  }
`;

const StyledText = styled(Text)`   
   word-break: break-all !important;
`;
